interface State {
  notice_by_app: number
  notice_by_mail: number
  msg_notice_from_favo: number
  msg_notice_from_site: number
  msg_notice_from_fuzai: number
  msg_notice_from_iine: number
  app_notice_vib: number
  app_notice_sound: number
  mail: string
}

const defaultState: State = {
  notice_by_app: 1,
  notice_by_mail: 0,
  msg_notice_from_favo: 0,
  msg_notice_from_site: 1,
  msg_notice_from_fuzai: 1,
  msg_notice_from_iine: 1,
  app_notice_vib: 1,
  app_notice_sound: 1,
  mail: ''
}

const state: State = Object.assign({}, defaultState)

const mutations = {
  resetState(state: State) {
    const s = defaultState
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },

  set_notice_by_app(state: State, noticeByApp: number) {
    state.notice_by_app = noticeByApp
  },
  set_notice_by_mail(state: State, noticeByMail: number) {
    state.notice_by_mail = noticeByMail
  },
  set_msg_notice_from_favo(state: State, msgNoticeFromFavo: number) {
    state.msg_notice_from_favo = msgNoticeFromFavo
  },
  set_msg_notice_from_site(state: State, msgNoticeFromSite: number) {
    state.msg_notice_from_site = msgNoticeFromSite
  },
  set_msg_notice_from_fuzai(state: State, msgNoticeFromFuzai: number) {
    state.msg_notice_from_fuzai = msgNoticeFromFuzai
  },
  set_msg_notice_from_iine(state: State, msgNoticeFromIine: number) {
    state.msg_notice_from_iine = msgNoticeFromIine
  },
  set_app_notice_vib(state: State, appNoticeVib: number) {
    state.app_notice_vib = appNoticeVib
  },
  set_app_notice_sound(state: State, appNoticeSound: number) {
    state.app_notice_sound = appNoticeSound
  },
  set_mail(state: State, mail: string) {
    state.mail = mail
  }
}

const actions = {}

const getters = {
  notice_by_app: (state: State): number => state.notice_by_app,
  notice_by_mail: (state: State): number => state.notice_by_mail,
  msg_notice_from_favo: (state: State): number => state.msg_notice_from_favo,
  msg_notice_from_site: (state: State): number => state.msg_notice_from_site,
  msg_notice_from_fuzai: (state: State): number => state.msg_notice_from_fuzai,
  msg_notice_from_iine: (state: State): number => state.msg_notice_from_iine,
  app_notice_vib: (state: State): number => state.app_notice_vib,
  app_notice_sound: (state: State): number => state.app_notice_sound,
  mail: (state: State): string => state.mail
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
